import {
  Carousel,
  CarouselItem,
  Image,
  Drawer,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Button,
  InfiniteScroll,
  Popover,
  Input,
  Checkbox,
  Badge,
  Pagination,
  CollapseTransition,
  Divider,
  Loading,
} from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

export default {
  install(Vue) {
    Vue.use(Carousel);
    Vue.use(CarouselItem);
    Vue.use(Image);
    Vue.use(Drawer);
    Vue.use(Dropdown);
    Vue.use(DropdownMenu);
    Vue.use(DropdownItem);
    Vue.use(Button);
    Vue.use(InfiniteScroll);
    Vue.use(Popover);
    Vue.use(Input);
    Vue.use(Checkbox);
    Vue.use(Badge);
    Vue.use(Pagination);
    Vue.use(CollapseTransition);
    Vue.use(Divider);
    Vue.use(Loading);
  },
};
